import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/components/blogs/blogs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2352516833/src/unimig_frontend/components/hero/HeroSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2352516833/src/unimig_frontend/components/hero/TrustedBrands.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/components/homepage/SingleBanner.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/components/homepage/tab_swiper/slide_component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2352516833/src/unimig_frontend/components/homepage/TextCTABanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2352516833/src/unimig_frontend/components/homepage/video_swipe_module/VideoSwipeModule.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/components/ui/button.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2352516833/src/unimig_frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
